@if ($model() != null && $currentUser() != null) {
    <div class="wrapper px-1">
        <!-- Seletor de papel -->
        @if ($shouldLetPublicAgentInteract() && $hasPendingTask() && $papeisSelector().length > 0 && !$isReadOnly()) {
            <papel-selector [class.mandatory]="$forgotPapel() && Utils.isNullOrEmpty($inputData().eDocsData.signerId)"
                            [_signerId]="$inputData().eDocsData.signerId"
                            [_isReadOnly]="$isReadOnly()"
                            [_papeis]="$papeisSelector()"
                            [_flowObjectType]="FlowObjectType.TaskFinishContent"
                            (_signerIdChange)="signerIdChange($event)"
            ></papel-selector>
            <hr />
        }

        @if (!$hasPendingTask()) {
            <!-- Task info: Realizada -->
            <div class="message-container">
                @if ($isTextContentType()) {
                    <div class="mb-3">
                        O seguinte conteúdo foi fornecido pelo setor responsável ao executar esta Tarefa de Encerramento:
                    </div>
                    <div>
                        <i class="document-highlight info-font">{{$inputData().message}}</i>
                    </div>

                    <hr />

                    <div class="mb-3">
                        Documento comprobatório da realização desta Tarefa:
                    </div>
                } @else {
                    <div class="mb-3">
                        @if ($isPlural()) {
                            <span>Os seguintes documentos anexos foram fornecidos</span>
                        } @else {
                            <span>O seguinte documento anexo foi fornecido</span>
                        }

                        <span> pelo setor responsável ao executar esta Tarefa de Encerramento:</span>
                    </div>
                }

                <div class="documents-container">
                    @for (doc of $currentDocuments(); track doc) {
                        <div class="position-relative my-1">
                            <span class="document-highlight" (click)="openDocumentModal(doc.id)" (keyDown)="openDocumentModal(doc.id)">
                                <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do documento">{{doc.registro}}</span>
                                <span class="info-font d-inline-block" matTooltip="Clique para visualizar o documento que foi capturado no E-Docs">
                                    <i class="fas fa-external-link-alt mr-2"></i><u>{{doc.filename}}</u>
                                </span>
                            </span>
                        </div>
                    }
                </div>

                <hr />

                <!-- Mensagem pública customizada -->
                @if (Utils.isNotNullOrEmpty($publicMessageHtml())) {
                    <div class="public-message py-1"
                         [class.loading]="$isPublicMessageHtmlLoading()"
                         [safeHtmlContent]="$publicMessageHtml()"
                    >{{Enums.Messages.DefaultLoadingText}}</div>
                } @else {
                    <!-- Mensagem padrão -->
                    <div><span>Fluxo <b>encerrado</b></span></div>
                }
            </div>
        } @else {
            <!-- Task info: Iniciada -->
            @if (!$shouldLetPublicAgentInteract()) {
                <!-- Task body: visão do requerente -->
                <div class="message-container">
                    @if (Utils.isNotNullOrEmpty($waitingMessage())) {
                        <div class="public-message py-1"
                             [class.loading]="$isWaitingMessageLoading()"
                             [safeHtmlContent]="$waitingMessage()"
                        >{{Enums.Messages.DefaultLoadingText}}</div>
                    }
                </div>
            } @else {
                <!-- Task footer: visão do executor -->
                @if ($isTextContentType()) {
                    <!-- Conteúdo de texto -->
                    <div class="form-container">
                        <span><span style="color: red">*</span> Mensagem do conteúdo que será capturado como resultado desta Tarefa:</span>

                        <div class="input-container text-center mt-1 px-0">
                            <textarea id="message" rows="4"
                                        [class.minlength]="$isMissingMessage()"
                                        [ngModel]="$inputData().message"
                                        (change)="onChangeMessage($event.target.value)"
                            ></textarea>
                        </div>

                        <div class="footer mt-3">
                            <button type="button" class="btn btn-outline-primary" (click)="submit()" (keyDown)="submit()">Enviar</button>
                        </div>
                    </div>
                } @else {
                    <!-- Conteúdo de anexos -->
                    <div class="mb-3">
                        <span>Forneça </span>

                        @if ($isPlural()) {
                            <span>os documentos anexos configurados</span>
                        } @else {
                            <span>o documento anexo configurado</span>
                        }

                        <span> para captura no E-Docs ao se executar esta Tarefa:</span>
                    </div>

                    <div class="attachments-container">
                        @for (item of $configSchema()?.taskFinishContent?.extraContent.attachments; track item) {
                            <div class="attachment-row">
                                <div class="attachment-info">
                                    <span class="title">{{item.label}}</span>
                                    <span class="label">Valor Legal</span>
                                    <span class="value">{{getDocumentLegalValueCombination(item)}}</span>
                                    <span class="label">Classificação Documental</span>
                                    <span class="value">{{item.documentClass.name}}</span>
                                    <span class="label">Nível de Acesso</span>
                                    <span class="value">{{item.accessLevel.name}}</span>

                                    @if (item.accessLevel.legalReasoningsNames?.length > 0) {
                                        <span class="label">Fundamentação Legal</span>
                                        <span class="value">{{getLegalReasoningsNames(item)}}</span>
                                    }
                                </div>

                                <pdf-upload (valueChange)="onPdfUploadChange($event, item)"></pdf-upload>
                            </div>
                        }
                    </div>

                    <div class="footer mt-3">
                        <button type="button" class="btn btn-outline-primary" (click)="submit()" (keyDown)="submit()">Enviar</button>
                    </div>
                }
            }
        }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
